import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { TESTIMONIALS } from "../../lib/site";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-12">
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-2xl space-y-4 mb-12 lg:mb-16">
        <Eyebrow>Client Stories</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
          Business Owners Who Stopped{" "}
          <span className="gradient-accent-text">Worrying About Leads</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.12}>
            <div
              data-testid={`testimonial-card-${i}`}
              className="h-full glass-card rounded-2xl p-6 sm:p-8 hover:border-violet-500/30 transition-colors duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-sm sm:text-base text-slate-200 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="w-12 h-12 rounded-full object-cover ring-2 ring-blue-500/40"
                />
                <div className="flex-1 min-w-0">
                  <p className="font-display font-semibold text-white text-sm">{t.name}</p>
                  <p className="text-xs text-slate-400 truncate">{t.role}</p>
                </div>
                <div className="flex flex-col items-end gap-1.5 shrink-0">
                  <span className="text-[10px] font-mono2 uppercase tracking-widest text-slate-500 border border-white/10 rounded-full px-2 py-0.5">
                    {t.tag}
                  </span>
                  <span className="text-[10px] font-semibold text-emerald-400 bg-emerald-400/10 border border-emerald-400/20 rounded-full px-2 py-0.5">
                    {t.badge}
                  </span>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
